import './Pillars.css';

const pillars = [
  {
    icon: '🎯',
    color: '#5B80F5',
    colorPale: '#EEF3FF',
    number: '01',
    title: 'Autonomie',
    subtitle: 'Sentiment de contrôle et d\'engagement',
    desc: 'Les tâches sont co-construites avec l\'enfant, pas imposées. Il choisit ses avatars, évalue sa difficulté, donne son accord. Cette co-construction crée un sentiment de contrôle qui est le fondement de la motivation durable.',
    quote: '"L\'enfant ne subit pas ses routines : il les possède."',
    items: ['Co-construction des tâches', 'Choix de l\'avatar', 'Auto-évaluation de l\'effort', 'Validation collaborative'],
  },
  {
    icon: '🌱',
    color: '#10B981',
    colorPale: '#D1FAE5',
    number: '02',
    title: 'Compétence',
    subtitle: 'Progression visible et répétition',
    desc: 'Niveaux, points d\'XP, feedbacks immédiats — tout est conçu pour soutenir le sentiment de compétence. La répétition quotidienne ancre les habitudes selon les principes des neurosciences de l\'apprentissage.',
    quote: '"Chaque tâche accomplie est une preuve concrète de ce qu\'il est capable de faire."',
    items: ['Système XP et niveaux', 'Feedback immédiat', 'Répétition quotidienne', 'Progression visualisée'],
  },
  {
    icon: '❤️',
    color: '#EC4899',
    colorPale: '#FCE7F3',
    number: '03',
    title: 'Relation',
    subtitle: 'Lien affectif et confiance',
    desc: 'Les petits mots d\'Evo, la validation parentale, ces instants partagés — tout renforce le lien parent-enfant. Une relation positive et sécurisante est le meilleur terreau pour le développement de l\'autonomie.',
    quote: '"Ce n\'est pas une app, c\'est un moment complice."',
    items: ['Petits mots bienveillants', 'Validation des parents', 'Régulation émotionnelle', 'Confiance renforcée'],
  },
];

export default function Pillars() {
  return (
    <section className="pillars" id="philosophie">
      <div className="pillars__bg">
        <div className="pillars__bg-circle pillars__bg-circle--1" />
        <div className="pillars__bg-circle pillars__bg-circle--2" />
      </div>

      <div className="container">
        <div className="pillars__header">
          <div className="section-label">🧠 Notre approche</div>
          <h2 className="section-title">Une science au service de l'enfant</h2>
          <p className="section-subtitle">
            Evolify repose sur la théorie de l'autodétermination (Deci & Ryan) et les neurosciences de l'apprentissage. Trois piliers indissociables.
          </p>
        </div>

        {/* 3 grandes cartes colorées */}
        <div className="pillars__grid">
          {pillars.map((pillar, i) => (
            <div
              key={i}
              className="pillar-card"
              style={{ '--pc': pillar.color, '--pp': pillar.colorPale }}
            >
              {/* Numéro décoratif géant */}
              <div className="pillar-card__bg-num">{pillar.number}</div>

              {/* Top : icône verre dépoli + chip */}
              <div className="pillar-card__top">
                <div className="pillar-card__icon-wrap">
                  <span className="pillar-card__icon">{pillar.icon}</span>
                </div>
                <span className="pillar-card__chip">Pilier {pillar.number}</span>
              </div>

              {/* Contenu */}
              <h3 className="pillar-card__title">{pillar.title}</h3>
              <p className="pillar-card__sub">{pillar.subtitle}</p>
              <p className="pillar-card__desc">{pillar.desc}</p>

              {/* Citation */}
              <blockquote className="pillar-card__quote">
                <p>{pillar.quote}</p>
              </blockquote>

              {/* Tags blancs */}
              <ul className="pillar-card__tags">
                {pillar.items.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Note scientifique */}
        <div className="pillars__science">
          <div className="pillars__science-icon">🔬</div>
          <div className="pillars__science-text">
            <h4>Une gamification douce, non conditionnelle</h4>
            <p>Evolify ne crée pas de dépendance à la récompense. Les XP et récompenses sont des feedbacks d'information et des marqueurs de progression, pas de contrôle. Le Mode Autonomie prépare progressivement l'enfant à une motivation purement intrinsèque — agir pour lui-même, pas pour gagner des points.</p>
          </div>
          <div className="pillars__science-badge">
            <span>Basé sur la TAD</span>
            <small>Théorie de l'Autodétermination</small>
          </div>
        </div>
      </div>
    </section>
  );
}
